import { render, staticRenderFns } from "./WorkReport.vue?vue&type=template&id=6bce22c8&scoped=true"
import script from "./WorkReport.vue?vue&type=script&lang=js"
export * from "./WorkReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce22c8",
  null
  
)

export default component.exports